module.exports = __webpack_public_path__ + "img/icons.57ddb455.svg";